import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='college-savings-plans'
      advisorImageVariant='advisorF'
      headingText={<>Ready to start saving <WidowBlock>for college&#63;</WidowBlock></>}
      text='Our financial advisors will help you create a college savings plan so your children can go to the school (or schools) they want.'
    />
  );
};
